'use client'
import React from 'react'

import { BoldIcon } from '../../icons/Bold/index.js'
import { LeafButton } from '../Button.js'

export const BoldLeafButton = () => (
  <LeafButton format="bold">
    <BoldIcon />
  </LeafButton>
)
